import React from 'react';
import { MapPin } from 'lucide-react';

const fieldWorks = [
  {
    title: 'Hospitals (MC Sisters)',
    locations: 'Majnu Ka Tila, Jangpura, Seemapuri',
    image: require('../../assets/poster/hospital.jpeg')
  },
  {
    title: 'MPS: Public Spaces',
    locations: 'Reaching out to public crossroads & urban spaces',
    image: require('../../assets/poster/publicplace.jpeg')
  },
  {
    title: 'Parish Ministries',
    locations: '23 Parishes across Delhi NCR',
    image: require('../../assets/poster/parish.jpeg')
  },
  {
    title: 'Street Children',
    locations: 'Educational & care support ministries',
    image: require('../../assets/poster/streetChildren.jpeg')
  },
  {
    title: 'Rickshaw Pullers',
    locations: 'Solidarity & health support outreach',
    image: require('../../assets/poster/rickshaw.jpeg')
  },
  {
    title: 'Urban Poor (5 Slums)',
    locations: 'Seelampur, Jahangirpuri, Model Town, Majnu Ka Tila',
    image: require('../../assets/poster/slumChildren.jpeg')
  },
  {
    title: 'Prison Ministry',
    locations: 'Tihar Ashram & rehabilitation centers',
    image: require('../../assets/poster/TiharJail.jpeg')
  },
  {
    title: 'Tribal Ministry',
    locations: '8 centers in Delhi (2000+ people)',
    image: require('../../assets/poster/tribalPeople.jpeg')
  },
  {
    title: 'NECCOD',
    locations: 'North East Community Care & Outreach',
    image: require('../../assets/poster/neccod.jpeg')
  },
  {
    title: 'Jesuit Refugee Service',
    locations: 'Refugee accompaniment & educational aid',
    image: require('../../assets/poster/jrs.jpeg')
  },
  {
    title: 'Kat-Katha',
    locations: 'Empowerment & rehabilitation ministry',
    image: require('../../assets/poster/katkatha.jpeg')
  }
];

export default function FieldWorkContent() {
  return (
    <section className="container-fluid project my-5 py-4">
      <div className="container">
        <div className="text-center mx-auto pb-4" style={{ maxWidth: '750px' }}>
          <span className="text-burgundy fw-bold text-uppercase small" style={{ letterSpacing: '0.1em' }}>
            CONTEXTUAL PASTORAL INVOLVEMENT
          </span>
          <h2 className="vj-card-title display-6 fw-bold mt-1 text-dark-main">
            Our Field Work & Ministries
          </h2>
          <p className="text-muted mt-2">
            Active apostolic involvement throughout the academic years is an integral dimension of theological formation at Vidyajyoti. We engage directly with the struggles, aspirations, and realities of marginalized communities.
          </p>
        </div>

        <div className="row g-4">
          {fieldWorks.map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="project-item h-100">
                <div className="project-img">
                  <img src={item.image} alt={item.title} loading="lazy" />
                  <div className="project-content">
                    <h4>{item.title}</h4>
                    <p className="d-flex align-items-center gap-1 mb-0">
                      <MapPin size={14} className="text-gold flex-shrink-0" />
                      <span>{item.locations}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
